import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { appointmentsAPI, customersAPI, vehiclesAPI, servicesAPI, employeesAPI } from '../../services/api';
import toast from 'react-hot-toast';

const DAYS = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
const STATUS_MAP = {
  scheduled:   { bg:'#DBEAFE', color:'#1D4ED8', label:'Agendado' },
  confirmed:   { bg:'#D1FAE5', color:'#065F46', label:'Confirmado' },
  in_progress: { bg:'#FEF3C7', color:'#92400E', label:'Em andamento' },
  done:        { bg:'#D1FAE5', color:'#065F46', label:'Concluído' },
  cancelled:   { bg:'#FEE2E2', color:'#991B1B', label:'Cancelado' },
  no_show:     { bg:'#F3F4F6', color:'#6B7280', label:'Não compareceu' },
};
const inp = { width:'100%', padding:'9px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, outline:'none', boxSizing:'border-box', fontSize:'.9rem' };
const lbl = { display:'block', fontWeight:600, fontSize:'.8rem', marginBottom:5, color:'#374151' };

function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}
function getFirstWeekday(year, month) {
  return new Date(year, month, 1).getDay();
}

export default function AppointmentCalendar() {
  const navigate = useNavigate();
  const today = new Date();
  const [year, setYear]   = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());
  const [selected, setSelected] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [showForm, setShowForm]   = useState(false);
  const [form, setForm]           = useState({});
  const [editing, setEditing]     = useState(null);
  const [customers, setCustomers] = useState([]);
  const [vehicles, setVehicles]   = useState([]);
  const [services, setServices]   = useState([]);
  const [employees, setEmployees] = useState([]);
  const [slots, setSlots]         = useState([]);
  const [converting, setConverting] = useState(null); // agendamento sendo convertido

  const load = async () => {
    const r = await appointmentsAPI.list({ month: month + 1, year }).catch(() => ({ data:{ data:[] } }));
    setAppointments(r.data.data || []);
  };

  useEffect(() => { load(); }, [year, month]);

  useEffect(() => {
    if (showForm) {
      customersAPI.list({ limit:200 }).then(r => setCustomers(r.data.data || []));
      servicesAPI.list().then(r => setServices(r.data.data || []));
      employeesAPI.list().then(r => setEmployees(r.data.data || []));
    }
  }, [showForm]);

  useEffect(() => {
    if (form.customer_id) vehiclesAPI.byCustomer(form.customer_id).then(r => setVehicles(r.data.data || []));
  }, [form.customer_id]);

  useEffect(() => {
    if (form.date && form.vehicle_id && form.service_id) {
      appointmentsAPI.availableSlots({ date: form.date, service_id: form.service_id })
        .then(r => setSlots(r.data.data || []))
        .catch(() => setSlots([]));
    }
  }, [form.date, form.vehicle_id, form.service_id]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const daysInMonth = getDaysInMonth(year, month);
  const firstDay    = getFirstWeekday(year, month);
  const cells       = Array.from({ length: firstDay + daysInMonth }, (_, i) => i < firstDay ? null : i - firstDay + 1);

  const apptsByDay = appointments.reduce((acc, a) => {
    const d = new Date(a.scheduled_at).getDate();
    if (!acc[d]) acc[d] = [];
    acc[d].push(a);
    return acc;
  }, {});

  const dayAppts = selected ? (apptsByDay[selected] || []) : [];

  const prevMonth = () => { if (month === 0) { setYear(y=>y-1); setMonth(11); } else setMonth(m=>m-1); setSelected(null); };
  const nextMonth = () => { if (month === 11) { setYear(y=>y+1); setMonth(0); } else setMonth(m=>m+1); setSelected(null); };

  const MONTH_NAMES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await appointmentsAPI.update(editing.id, form);
      else         await appointmentsAPI.create(form);
      toast.success(editing ? 'Agendamento atualizado!' : 'Agendamento criado!');
      setShowForm(false); setForm({}); setEditing(null); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
  };

  const updateStatus = async (id, status) => {
    try {
      const r = await appointmentsAPI.updateStatus(id, { status });
      const orderId = r.data?.data?.order_id;
      if (status === 'in_progress' && orderId) {
        toast.success('O.S. criada automaticamente!');
        navigate(`/orders/${orderId}`);
        return;
      }
      toast.success('Status atualizado!');
      load();
    } catch { toast.error('Erro.'); }
  };

  const del = async (id) => {
    if (!window.confirm('Remover agendamento?')) return;
    try { await appointmentsAPI.delete(id); toast.success('Removido.'); load(); }
    catch { toast.error('Erro.'); }
  };

  const doConvert = async () => {
    if (!converting) return;
    try {
      const r = await appointmentsAPI.convertToOrder(converting.id);
      const orderId = r.data?.data?.order_id;
      toast.success('O.S. criada com sucesso!');
      setConverting(null);
      if (orderId) navigate(`/orders/${orderId}`);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erro ao criar O.S.');
    }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#0F172A' }}>Agenda</h1>
        <button onClick={()=>{setShowForm(true);setForm({ date: selected?`${year}-${String(month+1).padStart(2,'0')}-${String(selected).padStart(2,'0')}`:'' });setEditing(null)}}
          style={{ background:'#2563EB', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontWeight:600, cursor:'pointer' }}>
          + Novo Agendamento
        </button>
      </div>

      <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, overflow:'hidden', marginBottom:20 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'16px 20px', borderBottom:'1px solid #E5E7EB' }}>
          <button onClick={prevMonth} style={{ background:'none', border:'1px solid #E5E7EB', borderRadius:8, padding:'6px 14px', cursor:'pointer', fontWeight:700 }}>‹</button>
          <h2 style={{ fontWeight:700, color:'#0F172A', margin:0 }}>{MONTH_NAMES[month]} {year}</h2>
          <button onClick={nextMonth} style={{ background:'none', border:'1px solid #E5E7EB', borderRadius:8, padding:'6px 14px', cursor:'pointer', fontWeight:700 }}>›</button>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)' }}>
          {DAYS.map(d => (
            <div key={d} style={{ padding:'8px 0', textAlign:'center', fontSize:'.75rem', fontWeight:700, color:'#9CA3AF', borderBottom:'1px solid #F1F5F9' }}>{d}</div>
          ))}
          {cells.map((day, i) => {
            const isToday = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
            const isSelected = day === selected;
            const hasAppts = day && apptsByDay[day]?.length > 0;
            return (
              <div key={i} onClick={()=>day && setSelected(isSelected ? null : day)}
                style={{ minHeight:64, padding:6, borderRight: (i+1)%7===0 ? 'none' : '1px solid #F1F5F9', borderBottom:'1px solid #F1F5F9',
                  background: isSelected ? '#EFF6FF' : '#fff', cursor: day ? 'pointer' : 'default' }}>
                {day && (
                  <>
                    <div style={{ width:24, height:24, borderRadius:'50%', background:isToday?'#2563EB':'transparent',
                      color:isToday?'#fff':'#374151', display:'flex', alignItems:'center', justifyContent:'center',
                      fontSize:'.8rem', fontWeight:isToday||isSelected?700:400, marginBottom:4 }}>{day}</div>
                    {hasAppts && (
                      <div style={{ display:'flex', flexWrap:'wrap', gap:2 }}>
                        {(apptsByDay[day] || []).slice(0,3).map(a => {
                          const s = STATUS_MAP[a.status] || STATUS_MAP.scheduled;
                          return <div key={a.id} style={{ height:4, width:4, borderRadius:'50%', background:s.color }} />;
                        })}
                        {(apptsByDay[day]||[]).length > 3 && <span style={{ fontSize:'.6rem', color:'#9CA3AF' }}>+{(apptsByDay[day]||[]).length-3}</span>}
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {selected && (
        <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, padding:20 }}>
          <h3 style={{ fontWeight:700, color:'#0F172A', marginBottom:16 }}>
            Agendamentos em {String(selected).padStart(2,'0')}/{String(month+1).padStart(2,'0')}/{year}
          </h3>
          {dayAppts.length === 0
            ? <p style={{ color:'#9CA3AF', textAlign:'center', padding:'20px 0' }}>Nenhum agendamento neste dia.</p>
            : dayAppts.map(a => {
              const s = STATUS_MAP[a.status] || STATUS_MAP.scheduled;
              const time = new Date(a.scheduled_at).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
              return (
                <div key={a.id} style={{ border:'1px solid #E5E7EB', borderRadius:10, padding:'14px 16px', marginBottom:10, display:'flex', gap:12, alignItems:'center' }}>
                  <div style={{ fontWeight:700, color:'#2563EB', fontSize:'1.1rem', minWidth:40 }}>{time}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:600 }}>{a.customer_name || 'Cliente'}</div>
                    <div style={{ fontSize:'.8rem', color:'#6B7280' }}>{a.service_name} · {a.plate}</div>
                    {a.employee_name && <div style={{ fontSize:'.75rem', color:'#9CA3AF' }}>Responsável: {a.employee_name}</div>}
                  </div>
                  <span style={{ background:s.bg, color:s.color, borderRadius:6, padding:'3px 10px', fontSize:'.75rem', fontWeight:600 }}>{s.label}</span>
                  {a.order_id
                    ? (
                      <button onClick={()=>navigate(`/orders/${a.order_id}`)}
                        style={{ background:'#EFF6FF', color:'#2563EB', border:'1px solid #BFDBFE', borderRadius:6, padding:'5px 12px', cursor:'pointer', fontSize:'.75rem', fontWeight:600, whiteSpace:'nowrap' }}>
                        📋 Ver O.S.
                      </button>
                    )
                    : !['cancelled','no_show'].includes(a.status) && (
                      <button onClick={()=>setConverting(a)}
                        style={{ background:'#F0FDF4', color:'#16A34A', border:'1px solid #86EFAC', borderRadius:6, padding:'5px 12px', cursor:'pointer', fontSize:'.75rem', fontWeight:700, whiteSpace:'nowrap' }}>
                        + Abrir O.S.
                      </button>
                    )
                  }
                  <select value={a.status} onChange={e=>updateStatus(a.id,e.target.value)}
                    style={{ fontSize:'.75rem', padding:'4px 8px', border:'1px solid #E5E7EB', borderRadius:6, outline:'none' }}>
                    {Object.entries(STATUS_MAP).map(([v,{label}]) => <option key={v} value={v}>{label}</option>)}
                  </select>
                  <button onClick={()=>del(a.id)} style={{ background:'#FEF2F2', color:'#DC2626', border:'none', borderRadius:6, padding:'4px 10px', cursor:'pointer', fontSize:'.75rem' }}>✕</button>
                </div>
              );
            })
          }
        </div>
      )}

      {converting && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:460 }}>
            <h3 style={{ fontWeight:700, color:'#0F172A', marginBottom:4 }}>Abrir Ordem de Serviço</h3>
            <p style={{ color:'#6B7280', fontSize:'.9rem', marginBottom:20 }}>Confirme os dados do agendamento para criar a O.S.:</p>

            <div style={{ background:'#F8FAFC', borderRadius:10, padding:'16px 18px', marginBottom:20, display:'grid', gap:10 }}>
              <div style={{ display:'flex', gap:8 }}>
                <span style={{ fontSize:'.75rem', fontWeight:700, color:'#94A3B8', minWidth:80 }}>HORÁRIO</span>
                <span style={{ fontWeight:600, color:'#0F172A' }}>
                  {new Date(converting.scheduled_at).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' })}
                </span>
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <span style={{ fontSize:'.75rem', fontWeight:700, color:'#94A3B8', minWidth:80 }}>CLIENTE</span>
                <span style={{ fontWeight:600, color:'#0F172A' }}>{converting.display_name || converting.customer_name || '—'}</span>
              </div>
              {(converting.vehicle_plate || converting.display_phone || converting.customer_phone) && (
                <div style={{ display:'flex', gap:8 }}>
                  <span style={{ fontSize:'.75rem', fontWeight:700, color:'#94A3B8', minWidth:80 }}>PLACA</span>
                  <span style={{ fontWeight:600, color:'#0F172A', fontFamily:'monospace' }}>{converting.vehicle_plate || '—'}</span>
                </div>
              )}
              {converting.service_name && (
                <div style={{ display:'flex', gap:8 }}>
                  <span style={{ fontSize:'.75rem', fontWeight:700, color:'#94A3B8', minWidth:80 }}>SERVIÇO</span>
                  <span style={{ color:'#374151' }}>{converting.service_name}</span>
                </div>
              )}
              {converting.employee_name && (
                <div style={{ display:'flex', gap:8 }}>
                  <span style={{ fontSize:'.75rem', fontWeight:700, color:'#94A3B8', minWidth:80 }}>RESPONSÁVEL</span>
                  <span style={{ color:'#374151' }}>{converting.employee_name}</span>
                </div>
              )}
              {converting.notes && (
                <div style={{ display:'flex', gap:8 }}>
                  <span style={{ fontSize:'.75rem', fontWeight:700, color:'#94A3B8', minWidth:80 }}>OBS.</span>
                  <span style={{ color:'#6B7280', fontSize:'.85rem' }}>{converting.notes}</span>
                </div>
              )}
            </div>

            <p style={{ fontSize:'.82rem', color:'#6B7280', marginBottom:20 }}>
              A O.S. será criada com os dados acima. Você poderá editar serviços, adicionar itens e fotos na tela de O.S.
            </p>

            <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button onClick={()=>setConverting(null)}
                style={{ padding:'10px 20px', border:'1.5px solid #E5E7EB', borderRadius:8, background:'#fff', cursor:'pointer', fontWeight:600 }}>
                Cancelar
              </button>
              <button onClick={doConvert}
                style={{ padding:'10px 24px', background:'#16A34A', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', fontSize:'.95rem' }}>
                ✓ Criar O.S.
              </button>
            </div>
          </div>
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:520, maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ fontWeight:700, marginBottom:20 }}>{editing?'Editar':'Novo'} Agendamento</h3>
            <form onSubmit={save}>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Cliente *</label>
                <select value={form.customer_id||''} onChange={e=>set('customer_id',e.target.value)} required style={inp}>
                  <option value="">Selecione</option>
                  {customers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              {form.customer_id && (
                <div style={{ marginBottom:14 }}>
                  <label style={lbl}>Veículo *</label>
                  <select value={form.vehicle_id||''} onChange={e=>set('vehicle_id',e.target.value)} required style={inp}>
                    <option value="">Selecione</option>
                    {vehicles.map(v=><option key={v.id} value={v.id}>{v.plate} — {v.model}</option>)}
                  </select>
                </div>
              )}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
                <div>
                  <label style={lbl}>Serviço *</label>
                  <select value={form.service_id||''} onChange={e=>set('service_id',e.target.value)} required style={inp}>
                    <option value="">Selecione</option>
                    {services.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Responsável</label>
                  <select value={form.employee_id||''} onChange={e=>set('employee_id',e.target.value)} style={inp}>
                    <option value="">Sem responsável</option>
                    {employees.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
                <div>
                  <label style={lbl}>Data *</label>
                  <input type="date" value={form.date||''} onChange={e=>set('date',e.target.value)} required style={inp} />
                </div>
                <div>
                  <label style={lbl}>Horário *</label>
                  {slots.length > 0
                    ? <select value={form.time||''} onChange={e=>set('time',e.target.value)} required style={inp}>
                        <option value="">Selecione</option>
                        {slots.map(s=><option key={s} value={s}>{s}</option>)}
                      </select>
                    : <input type="time" value={form.time||''} onChange={e=>set('time',e.target.value)} required style={inp} />
                  }
                </div>
              </div>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Observações</label>
                <textarea value={form.notes||''} onChange={e=>set('notes',e.target.value)} rows={2} style={{ ...inp, resize:'vertical' }} />
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                <button type="button" onClick={()=>setShowForm(false)} style={{ padding:'10px 20px', border:'1.5px solid #E5E7EB', borderRadius:8, background:'#fff', cursor:'pointer' }}>Cancelar</button>
                <button type="submit" style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
